module.exports = __webpack_public_path__ + "img/spinner.3586e94c.svg";